import { Button, Card } from "react-bootstrap";
import "./dashboard-card.sass";
import { Link } from "react-router-dom";
import { useState, useContext } from "react";
import { EditDashboard, AddTags } from "../edit-dashboard/edit-dashboard";
import { ReportingContext } from "../../pages/home/home";
import { PERMISSIONS } from "../../common/constants";
import { Can } from "../permission/can";

const customCardStyle = {
  height: "12.1rem",
  border: "none",
  borderRadius: "unset",
};

export const DashboardCard = ({
  id,
  name,
  link,
  permissions,
  embedUrl,
  datasetId,
  created_at,
  tags,
  creator,
  description,
  loadReports,
  optionsWorksTag,
  setLoading,
  setShowSuccessAlert,
}) => {
  const [flipped, setFlipped] = useState(false);

  return (
    // <Card className={`dashboard-card ${flipped ? "flip" : ""}`} style={customCardStyle}>
    <div className={`dashboard-card ${flipped ? "flip" : ""}`}>
      <FrontSide
        setShowSuccessAlert={setShowSuccessAlert}
        reportPermissions={permissions}
        reportId={id}
        link={link}
        created={created_at}
        reportName={name}
        flipped={flipped}
        setFlipped={setFlipped}
        loadReports={loadReports}
        optionsWorksTag={optionsWorksTag}
        tags={tags}
        setLoading={setLoading}
      />
      <BackSide flipped={flipped} setFlipped={setFlipped} description={description} />
    </div>
  );
};

const LabelColorBox = ({ color, onClickBox }) => {
  return (
    <div style={{ paddingTop: "5px" }}>
      <div key={color} style={{}}>
        <span style={{ width: "0.8rem", height: "0.8rem", border: "2px solid white", borderRadius: "50%", backgroundColor: color }}>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </div>
    </div>
  );
};

const FrontSide = ({
  reportId,
  reportName,
  reportPermissions,
  link,
  created,
  flipped,
  setFlipped,
  loadReports,
  optionsWorksTag,
  tags,
  setLoading,
  setShowSuccessAlert,
}) => {
  const { getWorkSpacePermissions, setFavReports, getFavReports } = useContext(ReportingContext);
  const [editDashboard, setEditDashboard] = useState(false);
  const [showTagModal, setShowTagModal] = useState(false);

  const Favourite = getFavReports()?.includes(reportId) ? true : false;

  const toggleEditDashboard = () => {
    let val;
    if (!editDashboard) {
      val = reportId;
    }
    setEditDashboard(val);
  };

  return (
    <div className="front" style={{ border: Favourite ? "1px solid red" : "None" }}>
      <Card.Body style={{ padding: "1rem" }}>
        <div className="buttonsgroup" style={{ color: "white" }}>
          <Can
            userRoles={reportPermissions}
            requiredRoles={[PERMISSIONS["EDIT_REPORT"], PERMISSIONS["SHARE_REPORT_EXTERN"], PERMISSIONS["SHARE_REPORT_INTERN"]]}
          >
            <EditDashboard
              reportPermissions={reportPermissions}
              setShowSuccessAlert={setShowSuccessAlert}
              toggleEditDashboard={() => toggleEditDashboard()}
              reportingId={editDashboard}
              reportName={reportName}
              loadReports={loadReports}
            />
          </Can>

          <Can userRoles={reportPermissions} requiredRoles={[PERMISSIONS["ADD_REPORT_TAG"]]}>
            <AddTags
              toggleEditDashboard={() => toggleEditDashboard()}
              reportingId={reportId}
              reportName={reportName}
              loadReports={loadReports}
              optionsWorksTag={optionsWorksTag}
              reportTags={tags}
              setShowTagModal={setShowTagModal}
              showTagModal={showTagModal}
              userPermissions={getWorkSpacePermissions()}
              setLoading={setLoading}
            />
          </Can>
          <div className="symbol">
            <span className="material-symbols-outlined symbol-button" onClick={() => setFlipped(!flipped)}>
              more_horiz
            </span>
          </div>
        </div>
        <div className="body-wrapper">
          <div className="text-wrapper" style={{ paddingTop: "9px" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "0.5rem" }}>
              <span class="material-symbols-outlined">insert_chart</span>
              <span style={{ fontSize: "19px" }}>
                <Link
                  to={link}
                  style={{ color: "white", textDecoration: "none" }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#7BB0FF"; // Change color on hover
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "white"; // Revert color on mouse leave
                  }}
                  title={`Go to Dashboard: ${reportName}`}
                >
                  {reportName}
                </Link>
              </span>
            </div>
          </div>

          <div title={`Created on ${created}`} className="created-date">
            📆
            {`${created ?? "2025-02-21"}`}
          </div>
          <br></br>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "3px" }}>
              {tags.map((l, idx) => (
                <LabelColorBox color={l.color} key={idx} />
              ))}
            </div>
            <div style={{ backgroundColor: "white", borderRadius: "50px 50px 0 0" }}>
              <Button
                variant={Favourite ? "danger" : "outline-danger"}
                onClick={() => {
                  setFavReports(reportId);
                }}
                style={{
                  border: "1px solid #f1f5fe",
                  cursor: "pointer",
                  padding: "4px 5px 5px 5px",
                  borderRadius: "50px 50px 0 0",
                  width: "70px",
                  height: "38px",
                }}
              >
                <span class="material-symbols-outlined" style={{ fontSize: "25px" }}>
                  favorite
                </span>
              </Button>
            </div>
          </div>
        </div>
      </Card.Body>
    </div>
  );
};

const BackSide = ({ setFlipped, flipped, description }) => {
  return (
    <div className="back">
      <Card.Body style={{ padding: "1rem" }}>
        <div className="buttonsgroup" style={{ color: "white" }}>
          <div className="symbol">
            <span className="material-symbols-outlined symbol-button" onClick={() => setFlipped(!flipped)}>
              close
            </span>
          </div>
        </div>
        <div className="body-wrapper">
          <div className="text-wrapper" style={{ color: "white" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "0.5rem", fontSize: "17px", paddingTop: "10px" }}>
              <span class="material-symbols-outlined">description</span> Description: &nbsp;
              {description}
            </div>
          </div>
        </div>
      </Card.Body>
    </div>
  );
};
